const ExtraAbsorbentSVG = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      aria-hidden="true"
      focusable="false"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_101_390"
        style={{maskType: 'alpha'}}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="25"
      >
        <rect y="0.947266" width="24" height="24" fill="#D9D9D9"></rect>
      </mask>
      <g mask="url(#mask0_101_390)">
        <path
          d="M12.0084 5.58813L12 5.58043L11.9915 5.58818C10.5245 6.9385 9.31988 8.20981 8.37771 9.40213C7.43798 10.5913 6.7757 11.7023 6.39132 12.7349H5.35578C5.76034 11.5094 6.51374 10.1998 7.61656 8.80613C8.72263 7.40833 10.1837 5.89692 12 4.2719C13.8163 5.89692 15.2774 7.40833 16.3835 8.80613C17.4863 10.1998 18.2397 11.5094 18.6442 12.7349H17.6087C17.2244 11.7023 16.5663 10.5914 15.6349 9.40217C14.701 8.20981 13.4921 6.93846 12.0084 5.58813ZM11.2353 14.7599L6.61759 19.3774C6.49963 19.2501 6.39366 19.121 6.29967 18.9901L6.29966 18.9901C6.20478 18.8581 6.11141 18.7164 6.01953 18.5648L9.82444 14.7599H11.2353ZM8.84037 21.2021L8.83551 21.2136L8.84036 21.2021C8.67963 21.1345 8.5246 21.0497 8.37525 20.9476L14.5879 14.7599H15.9985L9.3486 21.3909C9.17318 21.3339 9.00377 21.271 8.84037 21.2021ZM12.1765 21.9099L18.9493 15.1811C18.9137 15.4974 18.8482 15.8038 18.7526 16.1003C18.6537 16.4073 18.5245 16.698 18.365 16.9724L13.9443 21.3739C13.6699 21.5333 13.3825 21.6583 13.0819 21.7489C12.7912 21.8365 12.4895 21.8902 12.1765 21.9099ZM5.00697 14.7599H6.48533L5.13771 16.1073C5.08452 15.8833 5.05045 15.6615 5.03548 15.4418C5.02044 15.2184 5.01094 14.9911 5.00697 14.7599Z"
          fill="#006633"
          stroke="#006633"
          strokeWidth="0.025"
        ></path>
      </g>
    </svg>
  );
};

export default ExtraAbsorbentSVG;
